import react from 'react';
import classes from "./sceEmailDropDown.scss";
class SceEmailDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue:"",
      emails:"",
      optionsOpen: false,
      show:"",

    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    let warningIcon; 
    this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  }
  componentDidMount(){
    document.addEventListener('mousedown', this.handleClickOutside);
    if(this.props.enrolledEmail){
      const updatedState = { ...this.state };
      updatedState.emailValue=this.props.enrolledEmail;
      this.setState(updatedState);
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  handleClickOutside(event) {
    if ((this.wrapperRef && !this.wrapperRef.contains(event.target)) && (event.target.id !=="PbViewEditSave") && (event.target.id!=="PbViewEditAdd")) {
       this.props.handleClickOutSideTextBox();
     }
  }
 valueUpdateHandler = (email) => {
    const updatedState = { ...this.state };
    updatedState.emailValue = email;
    updatedState.optionsOpen=false;
    updatedState.show="editShow";
    updatedState.emailErr=false;
    this.setState(updatedState,
      ()=>{
        this.props.valueCallBack(this.state.emailValue,this.state.show,this.state.emailErr);
      });
   
  }
  inputChangeHandler = async(e) => {
    if(e){
      e.target.value = e.target.value.trim();
      e.target.value = e.target.value.replace(/\s+/g,'');
    }
    const updatedState = { ...this.state };
    updatedState.emailValue = e.target.value;
    updatedState.optionsOpen=true;
    updatedState.show="addShow";
    await this.setState(updatedState,()=>{});
    this.validateEmail(this.state.emailValue);
    //this.props.valueCallBack(this.state.emailValue,this.state.show,this.state.emailErr);
    //await this.handleOnChange(this.state.emailValue);
    // let regex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
    // let emailVal=this.state.emailValue;
    // if ( regex.test(emailVal) ) {
      
    //   updatedState.emailErr=false;
    //   await this.setState(updatedState,()=>{});
    //   //this.setState({emailErr:false});
    //   //alert("valid");  
    // }
    // else {
    //   updatedState.emailErr=true;
    //   await this.setState(updatedState,()=>{});
    //   //this.setState({emailErr:true});
    //   //alert("invalid");
       
    // }
    this.props.valueCallBack(this.state.emailValue,this.state.show,this.state.emailErr);
  }
  validateEmail(emailId){
    let emailVal=app.appUtil.isValidEmail(emailId);
    const updatedState = { ...this.state };
    if (emailVal) {
      
      updatedState.emailErr=false;
      this.setState(updatedState,()=>{});
      
    }
    else {
      updatedState.emailErr=true;
      this.setState(updatedState,()=>{});
      
    }
    this.setState(updatedState);

  }
  onClickHandler(){
    const updatedState = { ...this.state };
    updatedState.optionsOpen=true;
    this.setState(updatedState);
  }

  onEmailTextKeyPressHandler = (e) => {
    if (e.key === ' ') {
        e.preventDefault();
    }
  }

  //isOptionsOpen = (val) => { this.setState({ optionsOpen: val }); }
  render() {
    return (
     
     <div ref={this.setWrapperRef} > 
        <div className={classes.dropdown}>
          <div className={classes.dropdownBtn}>
            <input className={(!this.state.emailErr) ? classes.inputChange : classes.errorChange}  
            type="text" placeholder={this.props.placeholder} value={this.state.emailValue} onClick={this.onClickHandler.bind(this)}  
            onChange={this.inputChangeHandler.bind(this)} 
            autoComplete={this.props.autoComplete}
            onKeyPress={(e) => this.onEmailTextKeyPressHandler(e)}
            />
            {""}   
          </div>
          <span>
          {this.state.emailErr ?
          
          <span><span><img className={classes.warningImg} src={this.warningIcon} /></span><span className={classes.emailError}>{"Please enter a valid email id."}</span></span> : null
           
            }
            </span>
          {(this.state.optionsOpen) ?
            <div className={classes.dropdownContent}>
              {this.props.emailIds.map((email)=>{
               return <div className={classes.dropdownItem} onClick={()=> this.valueUpdateHandler(email)}>
               {email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c)}
             </div>;
            })}
            </div>
            : null
          }
        </div>
      </div>
    );
  }

}
export default SceEmailDropDown;
